import React from 'react';
import { useAppDispatch } from 'flow/hooks/useRedux';
import { setSnackbar } from 'flow/actions/app-actions';
import Icon from 'flow/components/ui-components/Icon';
import MenuItem from 'flow/components/ui-components/MenuItem';
import useAppContext from 'flow/hooks/useAppContext';

interface Props {
    summary?: string;
}

const MenuItemCopySummary = ({ summary }: Props) => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();

    if (!summary) return null;

    const onClick = () => {
        void navigator.clipboard.writeText(summary).then(() => {
            dispatch(
                setSnackbar({
                    message: i18next.t('snackbar.copied_to_clipboard'),
                }),
            );
        });
    };

    return (
        <MenuItem onClick={onClick}>
            <div className="flex items-center gap-x-2">
                <Icon iconKey="copyOutlined" />
                {i18next.t('Tooltip.Copy.text')}
            </div>
        </MenuItem>
    );
};

export default MenuItemCopySummary;
